import { useState } from "react"
import { TextInput } from 'carbon-components-react';
import { useParams, useNavigate } from "react-router-dom";
import { toaster } from '../../helpers/toaster';

import Button from '../../components/Button/Button';
import { Container, InputContainer, TextInputContainer, PrimaryText, SecondaryText } from './Login';
import { resetPasswordConfirmAPI } from "../../api/resetPassword";

const ResetPasswordConfirm = () => {
  const [password1, setPassword1] = useState(null)
  const [password2, setPassword2] = useState(null)
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();

  let { userid, token } = useParams();
  console.log(userid, token)

  const onSubmit = () => {
    setIsProcessing(true);
    if (password1 !== password2) {
      toaster("Passwords do not match", "warning")

      setIsProcessing(false);
      return;
    }

    resetPasswordConfirmAPI(userid, token, password1)
    .then(_ => {
      toaster("Password has been reset successfully", "success")
      navigate('/');
    }).catch(e => {
      toaster("Password reset failed", "error")
    }).finally(() => {
      setIsProcessing(false);
    })
  };

  const onKeyEnter = (e) => {
    if(e.keyCode === 13) {
      onSubmit()
    }
  }

  return (
    <Container>
      <InputContainer
        onKeyDown={onKeyEnter}
      >
        <PrimaryText>Reset Password</PrimaryText>
        <SecondaryText>Enter your new password</SecondaryText>
        <TextInputContainer
          style={{marginTop: '10px', display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
        >
          <TextInput.PasswordInput
            id="reset-password-1"
            labelText=""
            placeholder='Enter password'
            onChange={e => setPassword1(e.target.value)}
            style={{display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
          />
        </TextInputContainer>
        <TextInputContainer
          style={{marginTop: '10px', display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
        >
          <TextInput.PasswordInput
            id="reset-password-2"
            labelText=""
            placeholder='Confirm password'
            onChange={e => setPassword2(e.target.value)}
            style={{display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
          />
        </TextInputContainer>
        <Button
          style={{ width: "100%", marginTop:10 }}
          onClick={onSubmit} disabled={isProcessing}>
          Set Password
        </Button>
      </InputContainer>
    </Container>
  )
}


export default ResetPasswordConfirm;
